// import Vue from 'vue'
import {
	db
} from '../resources/firebase'
import firebase from 'firebase/app'
import 'firebase/firestore'

export const storyMixin = {
	methods: {
		bookmark(story) {
			//Fixes maximum call stack error for stories saved from Stack
			delete story.prevStory
			delete story.nextStory

			//Get authorized user id
			const userID = this.$store.state.user.authUser.uid;
			story.dateBookmarked = Date.now()

			//Update user stories attribute with selected story
			db.collection("users").doc(userID).update({
					"stories": firebase.firestore.FieldValue.arrayUnion(story)
				})
				.then(() => {
					this.storyBookmarked = true
					this.$store.commit('bookmarkStory', story)

					//Show toast
					this.$toasted.show('Story saved', {
						theme: 'bubble',
						position: 'bottom-center',
						duration: 1500
					})
				})
				.catch((error) => {
					// console.log(error)
					throw new Error(error)
				})
		},
		unBookmark(story) {
			// In cases where atory is liked from a user's stack.
			// Stack stories contain prevStory and nextStory properties for story navigation in modal
			delete story.prevStory
			delete story.nextStory

			//Get authorized user id
			const userID = this.$store.state.user.authUser.uid;

			//Update user stories attribute with selected story
			db.collection("users").doc(userID).update({
					"stories": firebase.firestore.FieldValue.arrayRemove(story)
				})
				.then(() => {
					this.$store.commit('unbookmarkStory', story)

					//Show toast
					this.$toasted.show('Story removed', {
						theme: 'bubble',
						position: 'bottom-center',
						duration: 1500
					})
				})
				.catch((error) => {
					// console.log(error)
					throw new Error(error)
				})
		},
		async goToStory(story, from) {
			let storyTitle = story.title.replace(" ", "-")

			if (storyTitle.length > 1) {
				this.$router.push({
					name: 'story',
					params: {
						story,
						storyTitle
					},
					query: {
						url: story.url
					}
				})
			}

			this.$store.commit('updateRecentReadsActivity', story)
		},
		like(story) {
			// In cases where atory is liked from a user's stack.
			// Stack stories contain prevStory and nextStory properties for story navigation in modal
			delete story.prevStory
			delete story.nextStory

			//Get authorized user id
			const userID = this.$store.state.user.authUser.uid;
			story.dateLiked = Date.now()

			//Update user stories attribute with selected story
			db.collection("users").doc(userID).update({
					"likes": firebase.firestore.FieldValue.arrayUnion(story)
				})
				.then(() => {
					this.isLiked = true

					if (this.$route.params.username === this.$store.state.user.user.username) {
						if (this.$store.state.user.userView.likes.indexOf(story) < 0) {
							//Story should not be liked but still duplicated authuser likes
							this.$store.state.user.userView.likes.unshift(story)
						}
					}

					this.$store.commit('likeStory', story)

					//Show toast
					this.$toasted.show('Story liked', {
						theme: 'bubble',
						position: 'bottom-center',
						duration: 1500
					})
				})
				.catch((error) => {
					// console.log(error)
					throw new Error(error)
				})

		},
		unlike(story) {
			// In cases where atory is liked from a user's stack.
			// Stack stories contain prevStory and nextStory properties for story navigation in modal
			delete story.prevStory
			delete story.nextStory

			//Get authorized user id
			const userID = this.$store.state.user.authUser.uid;
			//Update user stories attribute with selected story
			db.collection("users").doc(userID).update({
					"likes": firebase.firestore.FieldValue.arrayRemove(story)
				})
				.then(() => {
					this.isLiked = true
					//If the user is on thier page
					if (this.$route.params.username === this.$store.state.user.user.username) {
						let storyToRemove = this.$store.state.user.userView.likes.indexOf(story)
						this.$store.state.user.userView.likes.splice(storyToRemove, 1)
						this.$store.commit('unlikeStory', story)
					} else {
						this.$store.commit('unlikeStory', story)
					}

					//Show toast
					this.$toasted.show('Story unliked', {
						theme: 'bubble',
						position: 'bottom-center',
						duration: 1500
					})
				})
				.catch((error) => {
					// console.log(error)
					throw new Error(error)
				})
		},
		share(story) {
			delete story.prevStory
			delete story.nextStory

			//Get authorized user id
			const userID = this.$store.state.user.authUser.uid;
			story.dateShared = Date.now()

			//Update user stories attribute with selected story
			db.collection("users").doc(userID).update({
					"shares": firebase.firestore.FieldValue.arrayUnion(story)
				})
				.then(() => {
					this.isShared = true
					if (this.$route.params.username === this.$store.state.user.user.username) {
						if (this.$store.state.user.userView.shares.indexOf(story) < 0) {
							//Story should not be liked but still duplicated authuser likes
							this.$store.state.user.userView.shares.unshift(story)
						}
					}

					this.$store.commit('shareStory', story)

					//Show toast
					this.$toasted.show('Story shared', {
						theme: 'bubble',
						position: 'bottom-center',
						duration: 1500
					})
				})
				.catch((error) => {
					// console.log(error)
					throw new Error(error)
				})
		},
		unshare(story) {
			// In cases where atory is liked from a user's stack.
			// Stack stories contain prevStory and nextStory properties for story navigation in modal
			delete story.prevStory
			delete story.nextStory

			//Get authorized user id
			const userID = this.$store.state.user.authUser.uid;

			//Update user stories attribute with selected story
			db.collection("users").doc(userID).update({
					"shares": firebase.firestore.FieldValue.arrayRemove(story)
				})
				.then(() => {
					this.isShared = true
					if (this.$route.params.username === this.$store.state.user.user.username) {
						let storyToRemove = this.$store.state.user.userView.shares.indexOf(story)
						this.$store.state.user.userView.shares.splice(storyToRemove, 1)
						this.$store.commit('unshareStory', story)
					} else {
						this.$store.commit('unshareStory', story)
					}

					//Show toast
					this.$toasted.show('Story unshared', {
						theme: 'bubble',
						position: 'bottom-center',
						duration: 1500
					})
				})
				.catch((error) => {
					// console.log(error)
					throw new Error(error)
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/storyMixin.js